module.exports = __webpack_public_path__ + "img/load-rawk-3.1d5a16d2.gif";